import { getContext } from '@/context';
import { MINIAPP_PACKAGE_ID } from '@/consts/configs';
import ANALYTICS_EVENT_NAMES from '@/consts/analytics';

/**
 * Sends an object_apply analytics event.
 * Fires when user successfully completes an edit (downloads content).
 */
const sendObjectApplyAnalytics = () => {
  try {
    const params = {
      usedtools: [MINIAPP_PACKAGE_ID],
    };

    getContext().handlers.sendAnalytics({
      eventName: ANALYTICS_EVENT_NAMES.OBJECT_APPLY,
      params,
    });
  } catch {
    // Failed to send analytics
  }
};

export default sendObjectApplyAnalytics;
